import ajax from '@/lib/ajax';
import store from '@/store';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import { AppModule } from '@/store/Auth/AppModule';
import JournalEntry from '@/models/Accounting/JournalEntries/JournalEntry';
import PermissionUtils from '@/lib/permissionUtils';

// Hardcoded for now until we can get chart of accounts from the API
const testData = [
    {
        id: "ee445e46-5c7c-4d24-ad23-d89cd9eaf136",
        date: "01/03/2023",
        eventType: "CREDIT_RECEIVED",
        eventId: "ee445e46-5c7c-4d24-ad23-d89cd9eaf136",
        transactionType: "FPS_INBOUND_PAYMENT",
        transactionId: "ee445e46-5c7c-4d24-ad23-d89cd9eaf136",
        subTransactionType: "",
        transactionAmount: "",
        createdAt: new Date(),
        bookingDate: new Date(),
        valueDate: new Date(),
        productId: "64d5bc2f-de13-4471-9cf8-9cbeb9efb93f",
        productIssueId: "8891fa0f-44c9-4f99-a7f5-ea88a91eb745",
        productType: "Deposit",
        productSubType: "Current Account",
        debitAccount: "ABC Bank Clearbank Seg Account (100021)",
        debitAmount: "15,000 GBP",
        creditAccount: "SaaScada Deposit Accounts (200090)",
        creditAmount: "15,000 GBP",
        notes: "Some notes about this Journal Entry",
    },
    {
        id: "d29768dc-cf35-4e3c-a5e0-a5eb8a6798f0",
        date: "01/03/2023",
        eventType: "INTEREST_ACCRUAL",
        eventId: "d29768dc-cf35-4e3c-a5e0-a5eb8a6798f0",
        transactionType: "DEPOSIT_FIXED_TERM_INTEREST",
        transactionId: "ee445e46-5c7c-4d24-ad23-d89cd9eaf136",
        subTransactionType: "",
        transactionAmount: "",
        createdAt: new Date(),
        bookingDate: new Date(),
        valueDate: new Date(),
        productId: "64d5bc2f-de13-4471-9cf8-9cbeb9efb93f",
        productIssueId: "8891fa0f-44c9-4f99-a7f5-ea88a91eb745",
        productType: "Deposit",
        productSubType: "Current Account",
        debitAccount: "Deposit Interest Payable SaaScada Accounts (400309)",
        debitAmount: "1.50 GBP",
        creditAccount: "SaaScada Interest Payable (200092)",
        creditAmount: "1.50 GBP",
        notes: "Some notes about this Journal Entry",
    },
    {
        id: "6d67660f-e1f6-4ed6-acd7-66009264e860",
        date: "02/03/2023",
        eventType: "INTEREST_ACCRUAL",
        eventId: "6d67660f-e1f6-4ed6-acd7-66009264e860",
        transactionType: "DEPOSIT_FIXED_TERM_INTEREST",
        transactionId: "6d67660f-e1f6-4ed6-acd7-66009264e860",
        subTransactionType: "",
        transactionAmount: "",
        createdAt: new Date(),
        bookingDate: new Date(),
        valueDate: new Date(),
        productId: "64d5bc2f-de13-4471-9cf8-9cbeb9efb93f",
        productIssueId: "8891fa0f-44c9-4f99-a7f5-ea88a91eb745",
        productType: "Deposit",
        productSubType: "Current Account",
        debitAccount: "Deposit Interest Payable SaaScada Accounts (400309)",
        debitAmount: "1.50 GBP",
        creditAccount: "SaaScada Interest Payable (200092)",
        creditAmount: "1.50 GBP",
        notes: "Some notes about this Journal Entry",
    },
    {
        id: "e8b7fa0a-bd99-4232-b629-1b7e3310d59f",
        date: "01/04/2023",
        eventType: "INTEREST_POSTED",
        eventId: "e8b7fa0a-bd99-4232-b629-1b7e3310d59f",
        transactionType: "DEPOSIT_FIXED_TERM_INTEREST",
        transactionId:  "e8b7fa0a-bd99-4232-b629-1b7e3310d59f",
        subTransactionType: "",
        transactionAmount: "",
        createdAt: new Date(),
        bookingDate: new Date(),
        valueDate: new Date(),
        productId: "1141d9a9-c986-46ec-b8c5-bf77dcd1475d",
        productIssueId: "ea0548f1-5f3a-4c98-a46c-66ba163b3898",
        productType: "Deposit",
        productSubType: "Fixed Term",
        debitAccount: "Deposit Interest Paid SaaScada Accounts (400310)",
        debitAmount: "45.00 GBP",
        creditAccount: "SaaScada Deposit Accounts (200090)",
        creditAmount: "45.00 GBP",
        notes: "Some notes about this Journal Entry",
    }
];

export interface IJournalEntriesState {
    loadingJournalEntries: boolean;
    loadingJournalEntry: boolean;
    journalEntries: JournalEntry[];
    totalJournalEntriesPages: number;
    journalEntry: JournalEntry;
    pageSize: number;
}

@Module({ dynamic: true, store, name: 'JournalEntriesModule', namespaced: true })
class JournalEntriesStore extends VuexModule implements IJournalEntriesState {

    public loadingJournalEntries: boolean = true;
    public loadingJournalEntry: boolean = false;
    public journalEntries: JournalEntry[] = [];
    public totalJournalEntriesPages: number = 1;
    public journalEntry: JournalEntry = new JournalEntry();
    public pageSize: number = PermissionUtils.getPageSize();

    @Action
    async getJournalEntries() {

        this.context.commit("setJournalEntries", testData);
        this.context.commit("setJournalEntriesTotalPages", testData.length);
        this.setLoadingJournalEntries(false);

        // this.setLoadingJournalEntries(true);

        // await ajax.get(`/portal-backend/fi-api/accounting/journal-entries`)
        // .then(response => {
        //     this.setLoadingJournalEntries(false);
        // })
        // .catch(error => {
        //     AppModule.handleApiError(error);
        //     this.setLoadingJournalEntries(false);
        // });
    }

    @Action
    async getJournalEntry(id: string) {

        // Hardcoded for now until we can get chart of accounts from the API
        const journalEntry = testData.find((entry) => { return entry.id === id; });

        this.context.commit("setJournalEntry", journalEntry);

        // this.setLoadingJournalEntry(true);

        // await ajax.get(`/portal-backend/fi-api/accounting/journal-entry/${id}`)
        // .then(response => {
        //     this.setLoadingJournalEntry(false);
        // })
        // .catch(error => {
        //     AppModule.handleApiError(error);
        //     this.setLoadingJournalEntry(false);
        // });
    }

    @Action
    cleanState() {
        this.context.commit("resetState");
    }

    @Mutation
    resetState() {
        this.loadingJournalEntries = true;
        this.loadingJournalEntry = false;
        this.journalEntries = [];
        this.journalEntry = new JournalEntry();
        this.totalJournalEntriesPages = 1;
    }

    @Mutation
    private async setLoadingJournalEntries(loading: boolean) {
        this.loadingJournalEntries = loading;
    }

    @Mutation
    private async setLoadingJournalEntry(loading: boolean) {
        this.loadingJournalEntry = loading;
    }

    @Mutation
    private async setJournalEntries(journalEntries: JournalEntry[]) {
        this.journalEntries = journalEntries;
    }

    @Mutation
    private async setJournalEntriesTotalPages(total: number) {
        this.totalJournalEntriesPages = Math.ceil(total/this.pageSize);
    }

    @Mutation
    private async setJournalEntry(journalEntry: JournalEntry) {
        this.journalEntry = journalEntry;
    }

}

export const JournalEntriesModule = getModule(JournalEntriesStore);